// Generated from products/analytics/shared/engagement.ts; run analytics generate:site-runtime.
import { z } from "zod";

export const ENGAGEMENT_HEARTBEAT_MS = 15_000;
export const ENGAGEMENT_IDLE_MS = 30 * 60_000;
export const ENGAGEMENT_MAX_MS = 31 * 86400_000;
export const EngagementReasonSchema = z.enum(["heartbeat", "hidden", "visible", "pagehide"]);
const MillisecondsSchema = z.number().int().min(0).max(ENGAGEMENT_MAX_MS);
export const EngagementSnapshotSchema = z
  .strictObject({
    pageVisitId: z.uuid(),
    elapsedMs: MillisecondsSchema,
    visibleMs: MillisecondsSchema,
    reason: EngagementReasonSchema,
    persisted: z.boolean().optional(),
  })
  .refine((v) => v.visibleMs <= v.elapsedMs, "Visible time exceeds elapsed time")
  .refine(
    (v) => v.persisted === undefined || v.reason === "pagehide",
    "Persisted is pagehide-only",
  );
export type EngagementSnapshot = z.infer<typeof EngagementSnapshotSchema>;

export const EngagementSessionSchema = z.strictObject({
  version: z.literal(1),
  visitorId: z.uuid(),
  sessionId: z.uuid(),
  nextSequence: z.number().int().min(0).max(2147483648),
  lastSignalAt: z.number().int().min(0).max(8640000000000000),
});
export type EngagementSession = z.infer<typeof EngagementSessionSchema>;
export const EngagementQuerySchema = z.strictObject({ projectId: z.uuid(), visitorId: z.uuid() });
export const EngagementPageSchema = z.strictObject({
  domainId: z.uuid(),
  sessionId: z.uuid(),
  pageVisitId: z.uuid(),
  pagePath: z.string().max(2048),
  elapsedMs: MillisecondsSchema,
  visibleMs: MillisecondsSchema,
  lastObservedAt: z.date(),
  lastReceivedAt: z.date(),
  reportedState: z.enum(["visible", "hidden", "pagehide"]),
  persisted: z.boolean().nullable(),
  sessionEndedEstimated: z.boolean(),
  estimatedSessionEndAt: z.date().nullable(),
  lowerBound: z.literal(true),
});
export const EngagementResponseSchema = z.strictObject({
  asOf: z.date(),
  pages: z.array(EngagementPageSchema).max(100),
  coverage: z.strictObject({
    observations: z.number().int().min(0).max(5000),
    partial: z.boolean(),
    timing: z.enum(["observed", "unknown"]),
  }),
});
export type EngagementResponse = z.infer<typeof EngagementResponseSchema>;
